import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ThorGameConfig} from "../../ThorGameConfig";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite, TweenLite} from "gsap";

/**
 * Created by Jerker Nord on 2019-07-03.
 */

export class ThorFSThorNearWinView extends BaseView {

    private static NEAR_WIN_ANIMATION_NAME:string = "ThorReel";
    private static SPINE_ASSET_NAME:string = "thorReel";

    private _FSThorNearWinAnimation:PIXI.spine.Spine;
    private _FSThorNearWinAnimationTween:SpineTween;
    private _reelPosition:PIXI.Point = new PIXI.Point(980, 332);
    private _enableTL:TimelineLite;
    private _disableTL:TimelineLite;

    private _layer:ScalableLayer;

    constructor() {
        super();
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.WIN_COUNT_UP.name);
        this._layer.addChild(this);
    }

    protected initAnimations():void {
        this._FSThorNearWinAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset(ThorFSThorNearWinView.SPINE_ASSET_NAME));
        this._FSThorNearWinAnimation.position = this._reelPosition;
        this._FSThorNearWinAnimation.alpha = 0;
        this.addChild(this._FSThorNearWinAnimation);

        this._FSThorNearWinAnimationTween = new SpineTween(this._FSThorNearWinAnimation, 0, ThorFSThorNearWinView.NEAR_WIN_ANIMATION_NAME, -1);
        this._FSThorNearWinAnimationTween.kill();
    }

    public enableNearWin():void {
        if(this._enableTL && this._enableTL.isActive()) {
            this._enableTL.pause();
            this._enableTL.kill();
        }
        this._enableTL = new TimelineLite();
        this._enableTL.add([
            () => this._FSThorNearWinAnimationTween.restart(),
            () => new TweenLite(this._FSThorNearWinAnimation, 0.2, {alpha : 1})
        ]);
    }

    public disableNearWin():void {
        if(this._FSThorNearWinAnimation.alpha == 1) {
            if(this._disableTL && this._disableTL.isActive()) {
                this._disableTL.pause();
                this._disableTL.kill();
            }
            this._disableTL = new TimelineLite();
            this._disableTL.add(() => new TweenLite(this._FSThorNearWinAnimation, 0.2, {alpha : 0}));
            this._disableTL.add(() => this._FSThorNearWinAnimationTween.kill());
        }
    }
}